import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContactService } from '../../features/contact/contact.service';
import { FlashMessageService } from '../../shared/components/flash-message/flash-message.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, TranslateModule, RouterModule, ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  providers: [ContactService]
})
export class FooterComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);

  public isBrowser: boolean;
  public selectedLang: string;
  newsletterForm!: FormGroup;
  newsletterSubmitted = false;

  constructor(
    private readonly fb: FormBuilder,
    public translate: TranslateService,
    private readonly contactService: ContactService,
    private readonly flashMessage: FlashMessageService,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.selectedLang = this.translate.getCurrentLang();
  }

  ngOnInit() {
    this.newsletterForm = this.fb.group({
      newsletter: ['', [Validators.required, Validators.email]]
    });
  }

  onNewsletterSubmit() {
    this.newsletterSubmitted = true;
    if (this.newsletterForm.invalid) {
      return;
    }
    const email = this.newsletterForm.value.newsletter;
    this.contactService.saveNewsletterInfo(email).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.flashMessage.showSuccessAlert(this.translate.instant('newsletter_success'));
        this.newsletterForm.reset();
        this.newsletterSubmitted = false;
      },
      error: (err) => {
        this.flashMessage.showErrorAlert(this.translate.instant('error-message'));
      }
    });
  }

}


